import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { Link, WithHostUrl } from "@quintype/components";

import ResponsiveImageWithFallback from "../../../../../atoms/responsive-image-with-fallback";

import styles from "./styles.m.css";
import { connect } from "react-redux";

const AlsoReadBase = ({ story, element, cinemaMode }) => {
  const linkedStoryId = get(element, ["metadata", "linked-story", "id"], "");
  const linkedStoryS3Key = get(story, ["linked-stories", linkedStoryId, "hero-image-s3-key"], "");
  const linkedStoryImageMetadata = get(story, ["linked-stories", linkedStoryId, "hero-image-metadata"], {});
  const linkedStoryUrl = get(story, ["linked-stories", linkedStoryId, "url"], "");
  const linkedStoryHeadline = get(story, ["linked-stories", linkedStoryId, "headline"], element.text);

  // Delete me once cinema_mode is off
  return (
    <WithHostUrl>
      {({ currentHostUrl }) =>
        !cinemaMode || linkedStoryUrl.startsWith(currentHostUrl) ? (
          <div className={styles["also-read-wrapper"]}>
            <h3 className={styles["also-read-headline"]}>Also Read</h3>
            <div className={styles["also-read-story"]}>
              <div className={styles["also-read-image"]}>
                <ResponsiveImageWithFallback
                  className={styles["image-wrapper"]}
                  slug={linkedStoryS3Key}
                  metadata={linkedStoryImageMetadata}
                  alt={linkedStoryHeadline}
                  imgParams={{ auto: ["format", "compress"] }}
                  sources={[
                    {
                      aspectRatio: [8, 5],
                      defaultWidth: 150,
                      widths: [100, 150, 200],
                      sizes: "(max-width: 768px) 30vw, 25vw"
                    }
                  ]}
                  story={story}
                />
              </div>
              <div className={styles["also-read-content"]}>
                <Link
                  aria-label={`${"Read full story: "} ${linkedStoryHeadline}`}
                  href={linkedStoryUrl}
                  externalLink={linkedStoryUrl}
                >
                  <h4 className={`${styles["story-headline"]} ${styles["story-also-headline"]}`}>
                    {linkedStoryHeadline}
                  </h4>
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <span />
        )
      }
    </WithHostUrl>
  );
};

AlsoReadBase.propTypes = {
  cinemaMode: PropTypes.bool,
  story: PropTypes.shape({
    "linked-stories": PropTypes.any
  }),
  element: PropTypes.shape({
    text: PropTypes.string,
    metadata: PropTypes.shape({
      "linked-stories": PropTypes.shape({
        id: PropTypes.string
      })
    })
  })
};

export const AlsoRead = connect(state => ({ cinemaMode: get(state, ["qt", "config", "cinemaMode"], false) }))(
  AlsoReadBase
);
